import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import NewProjectDialog from "../components/NewProjectDialog";

interface SessionRow {
  id: number;
  name: string;
  event: { name: string };
  layout: { name: string; venue: { name: string } };
}

export default function DashboardPage() {
  const { t } = useTranslation();
  const { user, hasPermission } = useAuth();
  const navigate = useNavigate();
  const [sessions, setSessions] = useState<SessionRow[] | null>(null);
  const [showDialog, setShowDialog] = useState(false);

  function reload() {
    api.eventSessions().then(setSessions as (rows: SessionRow[]) => void);
  }

  useEffect(reload, []);

  function handleCreated(eventSessionId: number) {
    setShowDialog(false);
    navigate(`/hallplan/${eventSessionId}`);
  }

  const canManageProjects = hasPermission("projects.manage");

  return (
    <div className="page-padded">
      <div className="dashboard-head">
        <div>
          <h1>{t("dashboard.heading")}</h1>
          <p>{t("dashboard.welcome", { name: user?.displayName })}</p>
        </div>
        {canManageProjects && sessions !== null && sessions.length > 0 && (
          <button className="btn-primary" onClick={() => setShowDialog(true)}>
            {t("dashboard.newProject")}
          </button>
        )}
      </div>

      <h2>{t("dashboard.sessions")}</h2>
      {sessions === null && <p>…</p>}

      {sessions?.length === 0 &&
        (canManageProjects ? (
          <div className="empty-state">
            <p>{t("dashboard.emptyState")}</p>
            <button className="btn-primary" onClick={() => setShowDialog(true)}>
              {t("dashboard.newProject")}
            </button>
          </div>
        ) : (
          <p>{t("dashboard.emptyStateNoPermission")}</p>
        ))}

      {sessions && sessions.length > 0 && (
        <ul className="project-list">
          {sessions.map((session) => (
            <li key={session.id}>
              <Link to={`/hallplan/${session.id}`}>
                {session.event.name} — {session.name} ({session.layout.venue.name})
              </Link>
            </li>
          ))}
        </ul>
      )}

      {showDialog && <NewProjectDialog onClose={() => setShowDialog(false)} onCreated={handleCreated} />}
    </div>
  );
}
